import useWebData from "../hooks/useWebData";

type Props = {
    btnType: string;
    name: string;
    height: string;
    isBorderBtn: boolean;
    isProcessing?: boolean;
    onClickHandler: () => void;
    className?: string;
}

const Button = ({ btnType, name, height, isBorderBtn, isProcessing, onClickHandler, className = "" }: Props) => {
    const { webData }: any = useWebData();

    return (
        <button
            style={{
                background: isBorderBtn ? "white" : webData?.websiteHeaderColor,
                borderColor: webData?.websiteHeaderColor,
                color: isBorderBtn ? webData?.websiteHeaderColor : "white"
            }}
            type={btnType === "submit" ? btnType : btnType === "button" ? btnType : "reset"}
            className={`${className} mb-3 h-${height} inline-block rounded-md border ${isProcessing ? "cursor-wait" : "cursor-pointer"} ${isBorderBtn ? "text-primary bg-white border-primary" : "text-white bg-primary border-primary"} px-6 pt-2.5 pb-2 text-sm font-medium leading-normal transition duration-150 ease-in-out hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]`}
            onClick={onClickHandler}
        >
            {isProcessing ? "Processing" : name}
        </button>
    )
}

export default Button